<script>
  import { _ } from "svelte-i18n";
  import { onMount } from "svelte";
  import TextToSpeech2 from "./TextToSpeech2.svelte";
  import { mapPronToIpa } from "../../../utils/FormatUtils.svelte";
  import NumberFormatWith4Colors from "../../../components/NumberFormatWith4Colors.svelte";
  export let resultData; // = JSON.parse('{"exerciseKey":"cyWnql","studentName":"abc","fileName":"R_cyWnql_READ_abc_2020-12-22T21:35:49.882Z","data":{"RecognitionStatus":"Success","Offset":9300000,"Duration":11200000,"NBest":[{"Lexical":"Please read this text for me","ITN":"Please read this text for me","MaskedITN":"please read this text for me","Display":"Please read this text for me.","AccuracyScore":26,"FluencyScore":42,"CompletenessScore":33,"PronScore":30.6,"Words":[{"Word":"Please","AccuracyScore":0,"ErrorType":"Mispronunciation","Offset":9800000,"Duration":1100000,"Phonemes":[{"Phoneme":"p","AccuracyScore":0,"Offset":9800000,"Duration":200000},{"Phoneme":"l","AccuracyScore":0,"Offset":10100000,"Duration":200000},{"Phoneme":"iy","AccuracyScore":0,"Offset":10400000,"Duration":200000},{"Phoneme":"z","AccuracyScore":0,"Offset":10700000,"Duration":200000}]},{"Word":"read","AccuracyScore":15,"ErrorType":"Mispronunciation","Offset":11000000,"Duration":800000,"Phonemes":[{"Phoneme":"r","AccuracyScore":0,"Offset":11000000,"Duration":200000},{"Phoneme":"eh","AccuracyScore":0,"Offset":11300000,"Duration":200000},{"Phoneme":"d","AccuracyScore":46,"Offset":11600000,"Duration":200000}]},{"Word":"this","AccuracyScore":0,"ErrorType":"Mispronunciation","Offset":11900000,"Duration":800000,"Phonemes":[{"Phoneme":"dh","AccuracyScore":0,"Offset":11900000,"Duration":200000},{"Phoneme":"ih","AccuracyScore":0,"Offset":12200000,"Duration":200000},{"Phoneme":"s","AccuracyScore":0,"Offset":12500000,"Duration":200000}]},{"Word":"text","AccuracyScore":4,"ErrorType":"Mispronunciation","Offset":12800000,"Duration":1400000,"Phonemes":[{"Phoneme":"t","AccuracyScore":0,"Offset":12800000,"Duration":200000},{"Phoneme":"eh","AccuracyScore":0,"Offset":13100000,"Duration":200000},{"Phoneme":"k","AccuracyScore":19,"Offset":13400000,"Duration":200000},{"Phoneme":"s","AccuracyScore":0,"Offset":13700000,"Duration":200000},{"Phoneme":"t","AccuracyScore":0,"Offset":14000000,"Duration":200000}]},{"Word":"for","AccuracyScore":81,"ErrorType":"None","Offset":14300000,"Duration":1700000,"Phonemes":[{"Phoneme":"f","AccuracyScore":40,"Offset":14300000,"Duration":200000},{"Phoneme":"ax","AccuracyScore":46,"Offset":14600000,"Duration":200000},{"Phoneme":"r","AccuracyScore":100,"Offset":14900000,"Duration":1100000}]},{"Word":"me","AccuracyScore":56,"ErrorType":"None","Offset":16100000,"Duration":1300000,"Phonemes":[{"Phoneme":"eh","AccuracyScore":95,"Offset":16100000,"Duration":300000},{"Phoneme":"m","AccuracyScore":40,"Offset":16500000,"Duration":600000},{"Phoneme":"iy","AccuracyScore":40,"Offset":17200000,"Duration":200000}]}]}],"exerciseKey":"cyWnql","studentName":"abc","fileName":"R_cyWnql_READ_abc_2020-12-22T21:35:49.882Z"},"similarityValue":"0.00","accuracyScore":"26.00","accuracyScoreLabel":"poor","fluencyScore":"42.00","fluencyScoreLabel":"poor","completenessScore":"33.00","completenessScoreLabel":"poor","pronScore":"30.60","pronScoreLabel":"poor","wordCount":6,"overallScore":"72.67","overallScoreLabel":"poor"}');

  export let language;
  export let recordingUrl;
  let waveform;
  let wavesurfer;
  let waveformTimeline;
  let waveformSpectrogram;
  let playing = false;
  let selectedWord;

  onMount(async () => {
    console.log(resultData);
    console.log("recordingUrl", recordingUrl);
    //resultData = recordingDataDetail;
    initWaveWorm();
  });

  function initWaveWorm() {
    waveform.innerHTML = "";
    console.log("initWaveWorm");

    //waveform = document.getElementById("waveform");

    let wavesurferOptions = {
      container: "#phoneme-waveform",
      waveColor: "violet",
      progressColor: "purple",
      loaderColor: "purple",
      cursorColor: "navy",
      height: 80,
      plugins: [
        WaveSurfer.timeline.create({
          container: "#phoneme-wave-timeline",
        }),
        // WaveSurfer.spectrogram.create({
        //     wavesurfer: wavesurfer,
        //     container: "#phoneme-wave-spectrogram",
        //     labels: true
        // })
      ],
    };

    wavesurfer = WaveSurfer.create(wavesurferOptions);
    //wavesurfer.loadBlob(lastRecording.blob);
    if (recordingUrl) {
      wavesurfer.load(recordingUrl);
    }

    wavesurfer.drawer.on("click", function () {
      console.log("click wavesurfer");
      selectWordBySlice();
    });
  }

  function playPauseClick() {
    console.log("pauseAudio");
    wavesurfer.playPause();
    playing = wavesurfer.isPlaying();
    if (playing) {
      mixpanel.track(
        "Teacher Recording Page Text Analyzer Play Student Clicked",
      );
    }
  }

  function showDetailsForWordsMore(w) {
    mixpanel.track("Teacher Recording Page Text Analyzer Word Bubble Clicked");
    selectedWord = w;
    seekToWordSlice();
  }

  function replayWordSlice() {
    console.log("replayWordSlice", selectedWord);
    mixpanel.track(
      "Teacher Recording Page Text Analyzer Word Bubble Play Student Clicked",
    );
    let startTime = selectedWord.Offset / 10000000;
    let endTime = startTime + selectedWord.Duration / 10000000;
    wavesurfer.play(startTime, endTime);
  }

  function seekToWordSlice() {
    let startTime = selectedWord.Offset / 10000000;
    let seekTarget = startTime / wavesurfer.getDuration();

    if (seekTarget >= 0 && seekTarget <= 1) {
      wavesurfer.seekTo(seekTarget);
    }
  }

  function selectWordBySlice() {
    let position = wavesurfer.getCurrentTime();
    resultData?.NBest[0]?.Words.forEach((w) => {
      let startTime = w.Offset / 10000000;
      let endTime = startTime + w.Duration / 10000000;
      let inside = startTime <= position && position <= endTime;
      if (inside) {
        console.log(w.Word, inside);
        showDetailsForWordsMore(w);
      }
    });
  }

  function handleResize() {
    console.log("handleResize");
    initWaveWorm();
  }

  const scoreSettings = {
    greenTop: 90,
    orangeTop: 70,
    redTop: 50,
  };
</script>

<svelte:window on:resize={handleResize} />

<div>
  <div id="resultDetailsWithPhonemes">
    {#if resultData?.NBest?.length > 0}
      {#each resultData?.NBest[0]?.Words as w, i}
        {#if w.ErrorType !== "Insertion"}
          {#if w.SensayWordScore}
            {#if w.SensayWordScore > scoreSettings.greenTop && w.ErrorType === "None"}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <span
                class="badge badge-pill badge-excellent"
                on:click={() => showDetailsForWordsMore(w, i)}
                data-id={i}>{w.Word}</span
              >
            {:else if w.ErrorType === "Mispronunciation"}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <span
                class="badge badge-pill badge-miss"
                on:click={() => showDetailsForWordsMore(w, i)}
                data-id={i}>{w.Word}</span
              >
            {:else if w.ErrorType === "Omission"}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <span
                class="badge badge-pill badge-error"
                on:click={() => showDetailsForWordsMore(w, i)}
                data-id={i}>{w.Word}</span
              >
            {:else if w.SensayWordScore > scoreSettings.orangeTop}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <span
                class="badge badge-pill badge-good"
                on:click={() => showDetailsForWordsMore(w, i)}
                data-id={i}>{w.Word}</span
              >
            {:else if w.SensayWordScore > scoreSettings.redTop}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <span
                class="badge badge-pill badge-fair"
                on:click={() => showDetailsForWordsMore(w, i)}
                data-id={i}>{w.Word}</span
              >
            {:else if w?.ErrorType != "None"}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <span
                class="badge badge-pill badge-excellent"
                on:click={() => showDetailsForWordsMore(w, i)}
                data-id={i}>{w.Word}</span
              >
            {:else}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <span
                span
                class="badge badge-pill badge-bad"
                on:click={() => showDetailsForWordsMore(w, i)}
                data-id={i}>{w.Word}</span
              >
            {/if}
          {:else if w.AccuracyScore > scoreSettings.greenTop && w.ErrorType === "None"}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span
              class="badge badge-pill badge-excellent"
              on:click={() => showDetailsForWordsMore(w, i)}
              data-id={i}>{w.Word}</span
            >
          {:else if w.ErrorType === "Mispronunciation"}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span
              class="badge badge-pill badge-miss"
              on:click={() => showDetailsForWordsMore(w, i)}
              data-id={i}>{w.Word}</span
            >
          {:else if w.ErrorType === "Omission"}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span
              class="badge badge-pill badge-error"
              on:click={() => showDetailsForWordsMore(w, i)}
              data-id={i}>{w.Word}</span
            >
          {:else if w.AccuracyScore > scoreSettings.orangeTop}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span
              class="badge badge-pill badge-good"
              on:click={() => showDetailsForWordsMore(w, i)}
              data-id={i}>{w.Word}</span
            >
          {:else if w.AccuracyScore > scoreSettings.redTop}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span
              class="badge badge-pill badge-fair"
              on:click={() => showDetailsForWordsMore(w, i)}
              data-id={i}>{w.Word}</span
            >
          {:else if w?.ErrorType !== "None"}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span
              class="badge badge-pill badge-bad"
              on:click={() => showDetailsForWordsMore(w, i)}
              data-id={i}>{w.Word}</span
            >
          {:else}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span
              class="badge badge-pill badge-bad"
              on:click={() => showDetailsForWordsMore(w, i)}
              data-id={i}>{w.Word}</span
            >
          {/if}
        {/if}
      {/each}
      <!-- {#each resultData?.NBest[0]?.Words as w, i}
        {#if w.AccuracyScore > scoreSettings.greenTop && w.ErrorType === "None"}
          <span
            class="badge badge-pill badge-excellent"
            data-tooltip="Score: {w.AccuracyScore}"
            on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
          >
        {:else if w.AccuracyScore > scoreSettings.orangeTop}
          <span
            class="badge badge-pill badge-good"
            data-tooltip="Score: {w.AccuracyScore}"
            on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
          >
        {:else if w.ErrorType === 'Omission'}
          <span
            class="badge badge-pill badge-error"
            data-tooltip="Error: {w.ErrorType}"
            on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
          >
        {:else if w.ErrorType === 'Mispronunciation' || w.ErrorType === 'Insertion'}
          <span
            class="badge badge-pill badge-miss"
            data-tooltip="Error: {w.ErrorType}"
            on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
          >
        {:else if w.AccuracyScore > scoreSettings.redTop}
          <span
            class="badge badge-pill badge-fair"
            data-tooltip="Score: {w.AccuracyScore}"
            on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
          >
        {:else}
          <span
            class="badge badge-pill badge-bad"
            data-tooltip="Score: {w.AccuracyScore} - {w.ErrorType}"
            on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
          >
        {/if}
      {/each} -->
    {/if}
  </div>
  <div id="phoneme-waveform" bind:this={waveform} />
  <div id="phoneme-wave-timeline" bind:this={waveformTimeline} />
  <div id="phoneme-wave-spectrogram" bind:this={waveformSpectrogram} />

  <div id="resultDetailsWithPhonemesDetail">
    <div class="topSeparator mt-3" style="text-align: center;">
      {#key playing}
        <button
          class="btn btn-primary s-button-primary s-mr-10px"
          id="replayPlayStart"
          on:click={playPauseClick}
        >
          {#if playing}
            <i class="fas fa-pause s-mr-10px" />{$_("PAUSE")}{:else}<i
              class="fas fa-play s-mr-10px"
            />{$_("PLAY")}
          {/if}</button
        >
      {/key}
      {#if resultData?.NBest?.length}
        <TextToSpeech2 textToRead={resultData?.NBest[0].Display} {language} />
      {/if}
    </div>
    {#if selectedWord}
      <div>
        {$_("WORD")}
        <strong id="detailWord">{selectedWord?.Word || ""}</strong>
      </div>
      <div>
        {$_("SCORE")}
        <strong id="detailAccuracy">{selectedWord?.AccuracyScore || "0"}</strong
        >
      </div>
      {#if selectedWord?.ErrorType != "None"}
        <div>
          {$_("AREA_TO_IMPROVE")}
          <strong id="detailError">{selectedWord?.ErrorType || ""}</strong>
        </div>
      {/if}
    {:else}<div>{$_("PHONEME_BREAKDOWN.CTA")}</div>
    {/if}
    <div />

    <div>
      <table class="table">
        <thead>
          <th colspan="100%" style="text-align: center;">
            {#if selectedWord}
              <button
                class="btn btn-primary s-button-primary s-mr-10px"
                style="padding: 6px 12px 6px 12px"
                id="replayWord"
                on:click={replayWordSlice}
                disabled={selectedWord?.Duration === 0}
                >{$_("PLAY")}: "{selectedWord?.Word || ""}"</button
              >
              <TextToSpeech2 textToRead={selectedWord?.Word} {language} />
            {/if}
          </th>
        </thead>
        <tbody id="detailPhonemes" class="detailPhonemes">
          {#if Array.isArray(selectedWord?.Phonemes)}
            <tr>
              {#each selectedWord?.Phonemes as ph}
                <!-- <td><NumberFormatWith4Colors value={ph?.AccuracyScore} text={ph?.Phoneme} /></td> -->
                {#if ph?.AccuracyScore >= 90}
                  <td class="excellent">
                    {mapPronToIpa(ph?.Phoneme)}
                  </td>
                {:else if ph?.AccuracyScore > 70}
                  <td class="good">
                    {mapPronToIpa(ph?.Phoneme)}
                  </td>
                {:else if ph?.AccuracyScore > 50}
                  <td class="poor">
                    {mapPronToIpa(ph?.Phoneme)}
                  </td>
                {:else}
                  <td class="bad">
                    {mapPronToIpa(ph?.Phoneme)}
                  </td>
                {/if}
              {/each}
            </tr>
            <tr>
              {#each selectedWord?.Phonemes as ph}
                {#if ph?.AccuracyScore >= 90}
                  <td class="excellent">
                    {ph?.AccuracyScore.toFixed(0)}
                  </td>
                {:else if ph?.AccuracyScore > 70}
                  <td class="good">
                    {ph?.AccuracyScore.toFixed(0)}
                  </td>
                {:else if ph?.AccuracyScore > 50}
                  <td class="poor">
                    {ph?.AccuracyScore.toFixed(0)}
                  </td>
                {:else}
                  <td class="bad">
                    {ph?.AccuracyScore.toFixed(0)}
                  </td>
                {/if}
              {/each}
            </tr>
          {/if}
        </tbody>
      </table>
    </div>
  </div>
</div>

<style>
  .excellent {
    color: #008154;
    font-size: 1em;
  }

  .good {
    color: #40ac86;
    font-size: 1em;
  }

  .poor {
    color: #f7ba31;
    font-size: 1em;
  }

  .bad {
    color: #fe5b5b;
    font-size: 1em;
  }

  .badge {
    margin-right: 3px;
    font-weight: 500;
    font-size: 80%;
    padding-top: 0.4em;
    padding-bottom: 0.4em;
    cursor: pointer;
  }

  .badge-excellent {
    background: #008154ff;
    color: ivory;
  }

  .badge-good {
    background: #40ac86ff;
    color: ivory;
  }

  .badge-fair {
    background: #f7ba31ff;
    color: ivory;
  }

  .badge-bad {
    background: #fe5b5bff;
    color: ivory;
  }

  .badge-error {
    background: #fe5b5bff;
    color: ivory;
    text-decoration: line-through;
  }

  .badge-miss {
    background: #fe5b5bff;
    color: ivory;
    text-decoration-color: ivory;
    text-decoration-line: underline;
    /* text-decoration: dashed; */
  }

  .detailPhonemes td {
    text-align: center;
    padding: 1px;
  }
</style>
